module.exports = __webpack_public_path__ + "static/img/red.b9b52fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/red.png
// module id = VnT+
// module chunks = 1